﻿$(function () {
	$(document).on('change', '.check-all-parent', event => {
		event.preventDefault();
		let _self = $(event.currentTarget);
		let _children = _self.closest('table').find('tbody').find('.check-all-child');
		let _delete = _self.closest('thead').find('.check-all-delete');

		if (_self.is(':checked')) {
			$.each(_children, (_, child) => {
				$(child).prop('checked', true);
			});
			_delete.prop('disabled', false);
		}
		else {
			$.each(_children, (_, child) => {
				$(child).prop('checked', false);
			});
			_delete.prop('disabled', true);
		}
	});

	$(document).on('change', '.check-all-child', event => {
		event.preventDefault();
		let _self = $(event.currentTarget);
		let _parent = _self.closest('table').find('thead').find('.check-all-parent');
		let _children = _self.closest('tbody').find('.check-all-child');
		let _delete = _self.closest('table').find('thead').find('.check-all-delete');

		let allChecked = true;
		let someChecked = false;

		$.each(_children, (_, child) => {
			child = $(child);

			if (child.is(':checked')) {
				someChecked = true;
			}
			else {
				allChecked = false;
			}
		});

		if (allChecked) {
			_parent.prop('checked', true);
			_parent.prop('indeterminate', false);
			_delete.prop('disabled', false);
		}
		else if (someChecked) {
			_parent.prop('checked', false);
			_parent.prop('indeterminate', true);
			_delete.prop('disabled', false);
		}
		else {
			_parent.prop('checked', false);
			_parent.prop('indeterminate', false);
			_delete.prop('disabled', true);
		}
	});

	$(document).on('click', '.toggle-password', event => {
		event.preventDefault();
		let _self = $(event.currentTarget);
		let _input = _self.closest('.input-group').find('input').first();

		if (_self.is(':disabled'))
			return;

		if (_input.attr('type') === 'password') {
			_input.attr('type', 'text');
			_self.html('<span class="fas fa-fw fa-eye"></span>');
		}
		else {
			_input.attr('type', 'password');
			_self.html('<span class="fas fa-fw fa-eye-slash"></span>');
		}
	});
});
